import React from 'react';
import { withRouter } from 'react-router-dom';
import DataControlsEditor from './DataControlsEditor';
import SiteControlsEditor from './SiteControlsEditor';
import ExtensionControlsEditor from './ExtensionControlsEditor';
import { controlTypeFromSearch } from './GovernanceShared';

// Editor dispatcher — the control type rides the URL query param `?type=WEB|AI|DATA`
// (default DATA). Each control type is its own child component, so switching type
// cleanly mounts/unmounts the right editor (no rules-of-hooks issues from a
// conditional early-return inside one component).
//   DATA → DataControlsEditor (the original DATA rule editor, unchanged)
//   WEB / AI → SiteControlsEditor ("policy = site": create/edit one site keyed by
//              ?policyId=; create mode when the param is absent)
//   EXTENSION → ExtensionControlsEditor ("policy = extension": edit the one attached
//              rule keyed by ?policyId=. No create mode — an extension policy is
//              created by attaching a rule on the landing page, not here)
const GovernanceEditor = ({ location }) => {
  const type = controlTypeFromSearch(location && location.search);
  if (type === 'WEB' || type === 'AI') return <SiteControlsEditor controlType={type} />;
  if (type === 'EXTENSION') return <ExtensionControlsEditor />;
  return <DataControlsEditor />;
};

export default withRouter(GovernanceEditor);
